import {
    MdOutlineCollections,
    MdFormatPaint,
    MdAccessTime,
    MdOutlineLocalOffer, MdEdit, MdOutlineSave, MdOutlineCancel, MdCamera, MdCameraAlt, MdOutlineCameraAlt,
} from "react-icons/md";

import {IoMdHeartEmpty} from "react-icons/io";
import React, {useRef, useState} from "react";
import {MdVerified, MdOutlineContentCopy} from "react-icons/md";
import axios from "axios";
import {useUserAuth} from "../../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import {useDropzone} from 'react-dropzone';

const Banner = (props) => {
        const TARGET_HEIGHT = 80
        const TARGET_WIDTH = 80
        let {image, category, subCategory, name, productId, createdTime, profile, lastModified, mfg} = props;
        /*let newWallet = wallet.slice(0, 4);
        newWallet = newWallet.concat("...");
        newWallet = newWallet.concat(wallet.slice(wallet.length - 4, wallet.length));*/

        const [toggleState, setToggleState] = useState(1);
        const [productNameEditFlag, setProductNameEdit] = useState(false);

        const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
        const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

        //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
        const secretKey = "cromptonssecretkey";
        let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
        const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
        const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);

        const [errorMessage, setErrorMessage] = useState("");

        const [productName, setProductName] = useState(name);
        let [originalProductName, setOriginalProductName] = useState(name);
        let [uploadedImage, setUploadedImage] = useState("");

        const nameRef = useRef(null);

        const startEdit = () => {
            setProductNameEdit(true);
            setOriginalProductName(productName);
            // put current name into the editable element
            requestAnimationFrame(() => {
                if (nameRef.current) {
                    nameRef.current.textContent = productName;
                    nameRef.current.focus();
                }
            });
        };

        const save = () => {
            const newName = nameRef.current?.textContent ?? "";
            setProductName(newName);
            updateProductCatalogInfo(newName);
            setProductNameEdit(false);
        };

        const cancel = () => {
            if (nameRef.current) nameRef.current.textContent = originalProductName;
            setProductName(originalProductName);
            setProductNameEdit(false);
        };

        const navigate = useNavigate();

        const toggleTab = (index) => {
            setToggleState(index);
        };

        const handleLogOut = async () => {
            try {
                await logOut();
                navigate("/");
            } catch (error) {
                ////console.log(error.message);
            }
        }

        function updateProductCatalogInfo(newName) {
            //console.log(productName)
            let productCatalogInfo = {
                productId: productId,
                product: newName,
                mfg: mfg,
                unit: category,
                category: subCategory
            }

            //console.log(productCatalogInfo)

            return axios({
                method: 'post',
                url: CROMPTON_URL + 'product/update/productCatalog',
                data: productCatalogInfo,
                headers: {
                    Authorization: decryptedValue,
                }
            }).then(response => {
                //console.log(response)
                window.location.reload()
            })
                .catch(
                    error => {
                        //console.log(error)
                        setErrorMessage(error.response.data.message)

                        if (error.response.data.status === "401" || error.response.data.status === "403") {
                            handleLogOut();
                        }
                    }
                )
        }

        async function updateProductImage(image) {
            let productCatalogInfo = {
                productId: productId,
                product: productName,
                mfg: mfg,
                unit: category,
                category: subCategory
            }

            const bodyFormData = new FormData();
            //let blob

            const json = JSON.stringify(productCatalogInfo);
            const jsonBlob = new Blob([json], {
                type: 'application/json'
            });

            //blob = new Blob([uploadedImage], {type: uploadedImage.type});
            //console.log(updatedProductInfoImage.type)
            bodyFormData.append("productCatalogInfo", jsonBlob)
            bodyFormData.append("fileImage", image);

            //console.log(bodyFormData)

            //console.log(pid)
            var url = CROMPTON_URL + "product/update/productImage/" + productId
            await axios.post(url, bodyFormData, {
                headers: {
                    "Content-Type": "multipart/form-data", Authorization: decryptedValue
                },
            }).then((response) => {

                //setmessage("Successful")
                window.location.reload()
            }).catch((error) => {
                setErrorMessage(error.response.data.message)
                setUploadedImage("");
                //console.log(error);
                if (error.response.data.status === "401" || error.response.data.status === "403") {
                    handleLogOut();
                }
            })

        }

        const handleChange = (event) => {
            //console.log(event)
            setProductName(event.target.textContent);
        };

        function productNameEdit() {
            setProductNameEdit(true)
            setOriginalProductName(name)
            originalProductName = name
        }

        function cancelEdit() {
            setProductNameEdit(false);
            setProductName(originalProductName);
        }

        /*const handleImageChange = (event) => {
            if (event.target.files && event.target.files[0]) {
                setUploadedImage(event.target.files[0]);
                uploadedImage = event.target.files[0]
                updateProductImage(uploadedImage)
            }
        };*/

        const handleImageChange = (event) => {
            if (event.target.files && event.target.files[0]) {
                const file = event.target.files[0];

                // FileReader API for image processing
                const reader = new FileReader();

                reader.onload = (event) => {
                    const image = new Image();
                    image.onload = () => {
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');

                        // Calculate new dimensions while maintaining aspect ratio
                        const originalWidth = image.width;
                        const originalHeight = image.height;
                        let newWidth = 80;
                        let newHeight = 80;

                        // Preserve aspect ratio if original dimensions are different
                        if (originalWidth !== originalHeight) {
                            const aspectRatio = originalWidth / originalHeight;
                            if (originalWidth > originalHeight) {
                                newHeight = 80;
                                newWidth = Math.round(newHeight * aspectRatio);
                            } else {
                                newWidth = 80;
                                newHeight = Math.round(newWidth / aspectRatio);
                            }
                        }

                        // Set canvas dimensions
                        canvas.width = newWidth;
                        canvas.height = newHeight;

                        // Resize the image onto the canvas
                        ctx.drawImage(image, 0, 0, newWidth, newHeight);

                        // Convert resized image to data URL
                        canvas.toDataURL('image/jpeg', (dataURL) => {
                            const resizedImage = new Blob([dataURL.split(',')[1]], {type: 'image/jpeg'});
                            resizedImage.name = file.name; // Preserve original filename

                            // Check size and update state if valid (less than 1 MB)
                            if (resizedImage.size <= 1048576) {
                                setUploadedImage(resizedImage);
                            } else {
                                console.error('Image size exceeds 1 MB limit.');
                                // Handle error: image exceeds size limit (e.g., display error message)
                            }
                        });
                    };

                    image.src = event.target.result;
                };

                reader.readAsDataURL(file);
            }
        };

        function toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        }

        const getImageResolution = (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file); // Read image data as URL

                reader.onload = (event) => {
                    const img = new Image();
                    img.src = event.target.result;

                    img.onload = () => {
                        const width = img.width;
                        const height = img.height;
                        resolve({width, height}); // Return resolution

                        URL.revokeObjectURL(img.src); // Revoke temporary URL
                    };

                    img.onerror = (error) => {
                        reject(error); // Handle image loading error
                    };
                };

                reader.onerror = (error) => {
                    reject(error); // Handle file reading error
                };
            });
        };

        const onDrop = async acceptedFiles => {
            //console.log("inisde file drop")
            if (acceptedFiles.length > 0) {
                const file = acceptedFiles[0];

                //console.log(file.type)

                // Check for valid image types (optional)
                const validImageTypes = ['image/jpeg', 'image/png'];
                if (!validImageTypes.includes(file.type)) {
                    //console.error('Invalid image type. Please upload a JPEG or PNG file.');
                    setErrorMessage('Invalid image type. Please upload a JPEG or PNG file.')
                    return;
                }

                // Check for size limit (optional)
                if (file.size > 1048576) {  // 1 MB
                    setErrorMessage('Image size exceeds 1 MB limit.')
                    //console.error('Image size exceeds 1 MB limit.');
                    return;
                }

                getImageResolution(file)
                    .then(async (resolution) => {
                        //console.log(`Image resolution: ${resolution.width} x ${resolution.height}`);

                        if (resolution.width === TARGET_WIDTH && resolution.height === TARGET_HEIGHT) {
                            setErrorMessage("")
                            setUploadedImage(file);
                            uploadedImage = file


                            const base64String = await toBase64(file);
                            sessionStorage.setItem("updatedProductImage", base64String);
                            sessionStorage.setItem("updatedProductImageName", file.name);
                        } else {
                            setErrorMessage("Please upload file of 80*80 dimensions")
                        }

                    })
                    .catch((error) => {
                        console.error('Error getting image resolution:', error);
                    });

            }
        };

        const {getRootProps, getInputProps} = useDropzone({onDrop});

        return (

            <div
                className="flex h-full w-full flex-col items-center rounded-[20px] bg-cover bg-gradient-to-br from-[#004c86] to[#004c86] and-600 bg-no-repeat">
                <div className="relative flex h-[150px] w-full justify-center rounded-[20px]  xl:h-[220px]">
                    <span className="errorMessage">
                        {errorMessage}
                    </span>

                    {/*<div {...getRootProps()}>
                        <input {...getInputProps()} />
                        {uploadedImage ? (
                            <img src={URL.createObjectURL(uploadedImage)} alt="Uploaded preview" />
                        ) : (
                            <p>Drag & drop an image here, or click to select</p>
                        )}
                    </div>*/}

                    <div {...getRootProps()}
                         className="absolute -bottom-[70px] flex h-[180px] w-[180px] items-center justify-center rounded-full border-[1px] p-1 border-white bg-white dark:!border-navy-900 xl:h-[165px] xl:w-[165px]">
                        <input {...getInputProps()} />
                        {uploadedImage && (
                            <img src={URL.createObjectURL(uploadedImage)}
                                 className="h-full w-full rounded-full object-cover absolute top-0 left-0"
                                 alt="Uploaded preview"/>
                        )}
                        {
                            !uploadedImage &&
                            <img src={profile} className="h-full w-full rounded-full" alt=""/>
                        }
                        <div className="absolute bottom-0 right-0">
                            <input type="file" accept="image/*" hidden/>
                            <p
                                className="text-xl h-full w-full rounded-full bg-[#004c86] p-2 cursor-pointer"
                                /*onClick={() => document.querySelector('input[type="file"]').click()}*/
                            >
                                <MdOutlineCameraAlt className="text-gray-300"/>
                            </p>
                        </div>
                    </div>
                </div>

                <div className="mt-[90px] flex flex-col items-center">
                    <div className="flex items-center gap-2">
                        <p
                            ref={nameRef}
                            className="text-[35px] font-semibold text-navy-700 dark:text-white xl:text-[54px]"
                            contentEditable={productNameEditFlag}
                            suppressContentEditableWarning
                        >
                            {!productNameEditFlag ? productName : null}
                        </p>
                        {!productNameEditFlag ? (
                            <p style={{cursor: "pointer"}} onClick={startEdit}>
                                <MdEdit className="dark:text-gray-200"/>
                            </p>
                        ) : (
                            <div className="grid grid-cols-2 gap-2 items-center">
                                <MdOutlineSave className="text-green-800 cursor-pointer" onClick={save}/>
                                <MdOutlineCancel className="text-red-800 cursor-pointer" onClick={cancel}/>
                            </div>
                        )}
                    </div>
                    {/* <div className="flex items-center gap-2">
                        {productNameEditFlag === true ?
                            <p className="text-[35px] font-semibold text-navy-700 dark:text-white xl:text-[54px]"
                               contentEditable="true" onInputCapture={handleChange}>
                                {" "}
                                {productName}{" "}
                            </p> :
                            <p className="text-[35px] font-semibold text-navy-700 dark:text-white xl:text-[54px]"
                               contentEditable="false">
                                {" "}
                                {productName}{" "}
                            </p>
                        }
                        <p className="text-[35px] font-semibold text-navy-700 dark:text-white xl:text-[54px]" contentEditable={false} id= "productName">
                        {" "}
                        {name}{" "}
                    </p>
                        {productNameEditFlag === false ?
                            <p className="" style={{cursor: "pointer"}} onClick={productNameEdit}>
                                <MdEdit className="dark:text-gray-200"/>
                            </p>
                            :
                            <button
                                className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600 grid grid-cols-2 gap-2 items-center"
                                id="editButton">
                                <MdOutlineSave className="text-green-800" onClick={updateProductCatalogInfo}/>
                                <MdOutlineCancel className="text-red-800" onClick={cancelEdit}/>
                            </button>
                        }
                    </div>*/}
                    <div className="mt-[20px] flex cursor-pointer font-bold items-center gap-1 text-center text-gray-200">
                        <p /*onClick={function () {
                            navigator.clipboard.writeText(wallet);
                            alert("Product ID Copied");
                        }}*/>
                            {productId}
                        </p>
                        <p className=""
                           onClick={function () {
                               navigator.clipboard.writeText(productId);
                               alert("Product ID: " + productId + " Copied");
                           }}>
                            <MdOutlineContentCopy/>
                        </p>
                    </div>

                    <p className="mt-3 text-center text-lg font-bold text-[#004c86] dark:text-white">
                        {" "}
                        {category}{" "}{"| "}{subCategory}{" | "}{mfg.toString() === "1" ?
                        <span className="text-orange-400">TUYA</span> : <span className="text-[#004c86]">CROMPTON</span>}
                    </p>
                    <p className="mt-3 text-center text-lg font-bold text-navy-700 dark:text-white">
                        {" Created Time: "}
                        {createdTime}{" "}
                    </p>
                    <p className="mt-3 text-center text-lg font-bold text-navy-700 dark:text-white">
                        {" Last Modified: "}
                        {lastModified}{" "}
                    </p>

                    {uploadedImage &&
                        <p className="mt-3 text-center text-sm font-normal text-green-800 dark:text-green-800">
                            {"**Settings are modified and need to be saved before they can take effect."}
                        </p>
                    }


                    <br/>
                </div>

                {/* tabs */
                }
                {/*<div className="flex h-full w-full flex-col items-center overflow-x-scroll px-4 pt-[45px] lg:overflow-x-hidden lg:px-10">
        <div className="mt-[44px] flex w-full justify-between gap-16 overflow-hidden border-b-2 border-gray-200 text-3xl dark:!border-white/10 lg:gap-[50px] xl:justify-center xl:gap-[100px]">
          <div
            className={
              toggleState === 1
                ? " flex items-center gap-2 border-b-[4px] border-brand-500 pb-3 hover:cursor-pointer dark:border-brand-400"
                : "flex items-center gap-2 pb-[20px] hover:cursor-pointer"
            }
            onClick={() => toggleTab(1)}
          >
            <p className="text-lg text-navy-700 dark:text-white">
              <MdOutlineCollections />
            </p>
            <p className="text-[18px] font-medium text-navy-700 dark:text-white">
              Collected
            </p>
            <p className="text-lg text-gray-600">0</p>
          </div>

          <div
            className={
              toggleState === 2
                ? " flex items-center gap-2 border-b-[4px] border-brand-500 pb-3 hover:cursor-pointer dark:border-brand-400"
                : "flex items-center gap-2 pb-[20px] hover:cursor-pointer"
            }
            onClick={() => toggleTab(2)}
          >
            <p className="text-lg text-navy-700 dark:text-white">
              <MdFormatPaint />
            </p>
            <p className="text-[18px] font-medium text-navy-700 dark:text-white">
              Created
            </p>
            <p className="text-lg text-gray-600">4</p>
          </div>

          <div
            className={
              toggleState === 3
                ? " flex items-center gap-2 border-b-[4px] border-brand-500 pb-3 hover:cursor-pointer dark:border-brand-400"
                : "flex items-center gap-2 pb-[20px] hover:cursor-pointer"
            }
            onClick={() => toggleTab(3)}
          >
            <p className="text-lg text-navy-700 dark:text-white">
              <IoMdHeartEmpty />
            </p>
            <p className="text-[18px] font-medium text-navy-700 dark:text-white">
              Favorite
            </p>
            <p className="text-lg text-gray-600">12</p>
          </div>

          <div
            className={
              toggleState === 4
                ? " flex items-center gap-2 border-b-[4px] border-brand-500 pb-3 hover:cursor-pointer dark:border-brand-400"
                : "flex items-center gap-2 pb-[20px] hover:cursor-pointer"
            }
            onClick={() => toggleTab(4)}
          >
            <p className="text-lg text-navy-700 dark:text-white">
              <MdAccessTime />
            </p>
            <p className="text-[18px] font-medium text-navy-700 dark:text-white">
              Activity
            </p>
            <p className="text-lg text-gray-600">0</p>
          </div>

          <div
            className={
              toggleState === 5
                ? " flex items-center gap-2 border-b-[4px] border-brand-500 pb-3 hover:cursor-pointer dark:border-brand-400"
                : "flex items-center gap-2 pb-[20px] hover:cursor-pointer"
            }
            onClick={() => toggleTab(5)}
          >
            <p className="text-lg text-navy-700 dark:text-white">
              <MdOutlineLocalOffer />
            </p>
            <p className="text-[18px] font-medium text-navy-700 dark:text-white">
              Offers
            </p>
            <p className="text-lg text-gray-600">7</p>
          </div>
        </div>
      </div>*/
                }

            </div>

        )
            ;
    }
;

export default Banner;
